export const PageHero = ({ eyebrow, title, text, image, testid }) => (
  <section data-testid={testid} className="relative h-[52vh] min-h-[380px] overflow-hidden bg-[#1D3324] grain">
    {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover object-[center_52%] opacity-60" />}
    <div className="absolute inset-0 bg-gradient-to-t from-[#142419] via-[#142419]/40 to-transparent" />
    <div className="container-fv relative flex h-full flex-col justify-end pb-14 text-stone-100">
      <p className="eyebrow !text-[#C5A059] rise">{eyebrow}</p>
      <h1 className="f-display mt-4 text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.05] rise d1">{title}</h1>
      {text && <p className="mt-5 max-w-xl text-base text-stone-200/90 rise d2">{text}</p>}
    </div>
  </section>
);

export const SectionTitle = ({ eyebrow, title, className = "" }) => (
  <div className={className}>
    <p className="eyebrow">{eyebrow}</p>
    <h2 className="f-display mt-3 text-3xl sm:text-4xl text-[#1A1E1B] leading-tight">{title}</h2>
    <div className="gold-rule mt-5 w-32" />
  </div>
);
